

















import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'

@Component
export default class ContentItemStatusView extends Vue {
  @Prop({ required: true }) status: ContentItemStatus | string
  @Prop({ required: true }) statuses!: { [key in ContentItemStatus]: string }
  @Prop({ default: false }) dark: boolean
  @Prop({ default: false }) isIcon: boolean

  statusColor(prefix) {
    switch (this.status) {
      case ContentItemStatus.COMPLETED:
        return prefix + '-green'
      case ContentItemStatus.CANCELLED:
        return prefix + '-red'
      case ContentItemStatus.REJECTED:
        return prefix + '-deep-orange-8'
      case ContentItemStatus.EDITING:
        return prefix + '-yellow-9'
      case ContentItemStatus.PENDING:
        return prefix + '-amber-9'
      default:
        return prefix + '-blue'
    }
  }
}
